import React from 'react';
import './slickslider.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export function SlickSlider() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true
  };
  return (
    <Slider {...settings}>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Вакцинация</figcaption>
          <img className='slick-img' src="./img/slider/1.jpg" alt="Вакцинация" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Груминг</figcaption>
          <img className='slick-img' src="./img/slider/2.jpg" alt="Груминг" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Терапия</figcaption>
          <img className='slick-img' src="./img/slider/3.jpg" alt="Терапия" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Хирургия</figcaption>
          <img className='slick-img' src="./img/slider/4.jpg" alt="Хирургия" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Лаборатория</figcaption>
          <img className='slick-img' src="./img/slider/5.jpg" alt="Лаборатория" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'>Стационар</figcaption>
          <img className='slick-img' src="./img/slider/6.jpg" alt="Стационар" />
        </figure>
        <figure className='slick-block'>
          <figcaption className='slick-title'><a href="/#ambulance">Вызов врача на дом: днем = 500руб, ночью = 1000руб</a></figcaption>
          <img className='slick-img' src="./img/slider/7.jpg" alt="Вызов врача на дом" />
        </figure>
    </Slider>
  );
}
